import { useDispatch, useReduxState } from 'hooks';
import { actions } from 'store';
import { useApiHandlers } from 'lib/reader';
import { ConfirmButton } from 'components/common';
import { Icon } from 'components/common/icons';

interface Props {
  answerId: number;
  blockId: number;
}

const ReaderAnswerDelete = ({ answerId, blockId }: Props) => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { chapterData, readerCourseData, readOnly }
  } = useReduxState();

  const { onAnswerRemoved } = useApiHandlers();

  const handleRemoveAnswer = async () => {
    let success = true;
    if (answerId > 0 && onAnswerRemoved) {
      success = await onAnswerRemoved(answerId, blockId);
    }

    if (success) {
      dispatch(
        actions.updatePageState({
          chapterData: {
            ...chapterData,
            blocks: {
              ...chapterData.blocks,
              [blockId]: { ...chapterData.blocks[blockId], answerData: null }
            }
          }
        })
      );
      return true;
    }
  };

  const isPrivilegedUser =
    readerCourseData?.isSuperAdmin ||
    readerCourseData?.isCourseOwner ||
    (readerCourseData?.isCourseAdmin &&
      (readerCourseData?.courseAdminPermissions?.['review-tasks'] ||
        readerCourseData?.courseAdminPermissions?.['edit-content']));

  return readOnly || !answerId || !isPrivilegedUser ? null : (
    <div style={{ marginTop: 15, textAlign: 'right' }}>
      <ConfirmButton
        actionText={messages.commonDelete}
        buttonCategory="light"
        buttonIcon="trash-alt"
        buttonSize="small"
        buttonText={
          <div style={{ display: 'inline-block' }}>
            {messages.commonDeleteAnswer}

            <div
              aria-label={messages.tasksDeleteAnswerAdminTooltip}
              data-tooltip={messages.tasksDeleteAnswerAdminTooltip}
              style={{
                display: 'inline-block',
                marginLeft: 5,
                padding: '0px 2px',
                position: 'relative',
                top: 1
              }}
            >
              <Icon icon="question-circle" />
            </div>
          </div>
        }
        category="danger"
        confirmText={messages.commonDeleteAnswerConfirm}
        confirmTitle={messages.commonDeleteAnswer}
        onConfirm={handleRemoveAnswer}
      />
    </div>
  );
};

export default ReaderAnswerDelete;
